import { Schedule } from "../models/Schedule.tsx";

export type LiveScoreState = {
    home: number | null;
    away: number | null;
    period: number | null;
    clock: string | null;
};

export function readLiveScore(game: Schedule): LiveScoreState {
    return {
        home: game.result?.scores?.home?.total ?? null,
        away: game.result?.scores?.away?.total ?? null,
        period: game.result?.in_play_data?.period ?? null,
        clock: game.result?.in_play_data?.clock ?? null,
    };
}

const getOrdinalLabel = (n: number): string => {
    const v = n % 100;
    if (v >= 11 && v <= 13) return `${n}th`;
    switch (n % 10) {
        case 1: return `${n}st`;
        case 2: return `${n}nd`;
        case 3: return `${n}rd`;
        default: return `${n}th`;
    }
};

export function formatLivePeriodLabel(
    sport: string,
    leagueId: string,
    period: number | null,
    clock: string | null,
): string {
    const clockText = (clock ?? "").trim();
    const sportId = sport.trim().toLowerCase();
    const league = leagueId.trim().toLowerCase();
    const isBaseball = sportId === "baseball" || league === "mlb";

    if (isBaseball) {
        if (period != null && period > 0) return `(${getOrdinalLabel(period)})`;
        return "";
    }

    const periodLabel = (() => {
        if (period == null || period <= 0) return "";
        if (
            sportId === "basketball" || sportId === "football" ||
            ["nba", "nfl", "ncaab", "ncaaf", "wnba", "cfb", "cbb"].includes(league)
        ) {
            return period > 4 ? "OT" : `Q${period}`;
        }
        if (sportId === "hockey" || league === "nhl") {
            return period > 3 ? "OT" : `P${period}`;
        }
        if (sportId === "soccer" || league.includes("soccer") || league === "epl" || league === "mls") {
            return period <= 2 ? `${getOrdinalLabel(period)}` : "ET";
        }
        return getOrdinalLabel(period);
    })();

    const showClock = Boolean(clockText && clockText !== "00:00" && /:/.test(clockText));
    return [periodLabel, showClock ? clockText : ""].filter(Boolean).join(" ");
}
